// extracted by mini-css-extract-plugin
module.exports = {"eid_block":"EidBlock_eid_block__GSGHe","eid_block__title":"EidBlock_eid_block__title__D3cym","promo_bonus_text":"EidBlock_promo_bonus_text__DoIva"};